import React, { Component } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

export default (
    presentationAccessor,
    itemRequestActionCreator
) => PageComponent => {
    class InnerPageComponent extends Component {
        componentDidMount() {
            const { match, requestItem } = this.props
            if (match.params.id) {
                requestItem(match.params.id)
            }
        }

        render() {
            const { isFilterActive } = this.props
            return <PageComponent isFilterActive={isFilterActive} />
        }
    }

    const mapStateToProps = ({ presentation }) => ({
        isFilterActive: presentation[presentationAccessor].isFilterActive
    })

    const mapDispatchToProps = dispatch => ({
        requestItem: id => dispatch(itemRequestActionCreator(id))
    })

    return withRouter(
        connect(mapStateToProps, mapDispatchToProps)(InnerPageComponent)
    )
}
